import { configureStore } from '@reduxjs/toolkit';
import { AuthConfigs } from 'Utils/auth/authConfigs';
import rootReducer from './reducers';
const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // Ignore these action types
            ignoredActions: ['your/action/type'],
            // Ignore these field paths in all actions
            ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
            // Ignore these paths in the state
            ignoredPaths: ['monitoringEventFormModule']
        }
    }),
    devTools: AuthConfigs.IS_DEV_ENV
});
export default store;
